(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)');

  const pingCart = () => {
    const bubble = document.querySelector(
      '.cart-bubble, [class*="cart-bubble"], header-actions .count, .header-actions__cart-icon span'
    );
    const icon = document.querySelector('header-actions [href*="/cart"], a[href*="/cart"], cart-icon, .header-actions__cart-icon');
    const target = bubble || icon;
    if (!target) return;
    target.classList.remove('is-mmx-ping');
    void target.offsetWidth;
    target.classList.add('is-mmx-ping');
  };

  document.addEventListener('cart:update', pingCart);
  document.addEventListener('cart:refresh', pingCart);
  document.addEventListener('cart:updated', pingCart);

  const toast = document.createElement('p');
  toast.className = 'mmx-toast';
  toast.setAttribute('role', 'status');
  toast.hidden = true;
  document.body.appendChild(toast);
  let toastTimer;
  const showToast = (msg) => {
    toast.textContent = msg;
    toast.hidden = false;
    toast.classList.add('is-on');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(() => {
      toast.classList.remove('is-on');
      toast.hidden = true;
    }, 2200);
  };
  document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
    if (form.matches('[data-mmx-upsell-form]')) return;
    form.addEventListener('submit', () => showToast('Terrain ajouté à ton setup'));
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-mmx-upsell-form]');
    if (!form) return;
    event.preventDefault();
    const btn = form.querySelector('button[type="submit"]');
    const idField = form.querySelector('[name="id"]');
    const id = idField ? Number(idField.value) : 0;
    if (!id) {
      form.submit();
      return;
    }
    if (btn) btn.disabled = true;
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: id, quantity: 1 }],
        sections: ['cart-drawer-section'],
        sections_url: window.location.pathname
      })
    })
      .then((res) => {
        if (!res.ok) throw new Error('cart-add');
        return res.json();
      })
      .then((data) => {
        if (data.sections && data.sections['cart-drawer-section']) {
          const wrap = document.getElementById('shopify-section-cart-drawer-section');
          if (wrap) wrap.outerHTML = data.sections['cart-drawer-section'];
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: data }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        showToast('Terrain ajouté à ton setup');
        if (/\/cart\/?$/.test(window.location.pathname)) {
          window.location.reload();
          return;
        }
        const drawer = document.querySelector('#cart-drawer');
        if (drawer && typeof drawer.show === 'function') drawer.show();
        else if (drawer && typeof drawer.open === 'function') drawer.open();
      })
      .catch(() => {
        form.removeAttribute('data-mmx-upsell-form');
        form.submit();
      })
      .finally(() => {
        if (btn) btn.disabled = false;
      });
  });

  const copyCode = (code) => {
    const done = () => showToast('Code copié : ' + code);
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(() => {
        showToast(code);
      });
      return;
    }
    showToast(code);
  };

  document.addEventListener('click', (event) => {
    const chip = event.target.closest('[data-mmx-code]');
    if (!chip) return;
    const code = chip.getAttribute('data-mmx-code');
    if (!code) return;
    if (chip.tagName !== 'A') event.preventDefault();
    copyCode(code);
  });

  const quizRoot = document.querySelector('[data-mmx-quiz-root]');
  const quizDataEl = document.querySelector('[data-mmx-quiz-data]');
  if (quizRoot && quizDataEl) {
    let data = null;
    try {
      data = JSON.parse(quizDataEl.textContent);
    } catch (err) {
      data = null;
    }
    const questions = data && data.questions;
    const terrains = data && data.terrains;
    const hooks = (data && data.hooks) || {};
    if (questions && questions.length && terrains) {
      const progressEl = quizRoot.querySelector('[data-mmx-quiz-progress]');
      const questionEl = quizRoot.querySelector('[data-mmx-quiz-question]');
      const optionsEl = quizRoot.querySelector('[data-mmx-quiz-options]');
      const resultEl = quizRoot.querySelector('[data-mmx-quiz-result]');
      let step = 0;
      let playerId = 'aim';
      let universeKey = 'B';
      const pad = (n) => String(n).padStart(2, '0');

      const optionMeta = (raw, index) => {
        if (raw && typeof raw === 'object') {
          return {
            id: raw.id || String(index),
            label: raw.label || '',
            key: raw.key || raw.id
          };
        }
        const fallback = ['A', 'B', 'C', 'D'][index] || 'B';
        return { id: fallback, label: String(raw || ''), key: fallback };
      };

      const showQuestion = () => {
        const current = questions[step];
        if (progressEl) progressEl.textContent = pad(step + 1) + ' / ' + pad(questions.length);
        if (questionEl) questionEl.textContent = current.q;
        optionsEl.innerHTML = '';
        resultEl.hidden = true;
        current.a.forEach((raw, index) => {
          const opt = optionMeta(raw, index);
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'mmx-quiz__opt';
          const tag = opt.label.indexOf('/') > -1 ? opt.label.split('/')[0].trim() : '';
          btn.innerHTML = (tag ? '<span>' + tag + '</span>' : '') + '<strong>' + opt.label + '</strong>';
          btn.addEventListener('click', () => {
            if (current.id === 'player') playerId = opt.id;
            if (current.id === 'universe') universeKey = opt.id;
            if (!current.id) universeKey = opt.key;
            step += 1;
            if (step >= questions.length) showResult();
            else showQuestion();
          });
          optionsEl.appendChild(btn);
        });
      };

      const showResult = () => {
        const terrain = terrains[universeKey] || terrains.B;
        const hook = hooks[playerId] || '';
        if (progressEl) progressEl.textContent = 'Ton loadout';
        if (questionEl) questionEl.textContent = 'Ton loadout';
        optionsEl.innerHTML = '';
        resultEl.hidden = false;
        resultEl.innerHTML =
          '<article class="mmx-quiz__card mmx-quiz__card--' +
          (terrain.key || '') +
          '">' +
          (terrain.image
            ? '<img src="' + terrain.image + '" alt="' + (terrain.alt || terrain.name) + '" width="640" height="400">'
            : '') +
          '<p class="mmx-kicker">Ton loadout</p>' +
          '<h3>' +
          (terrain.loadout || terrain.name || '') +
          '</h3>' +
          '<p class="mmx-quiz__line">' +
          (terrain.line || '') +
          '</p>' +
          (hook ? '<p>' + hook + '</p>' : '') +
          (terrain.copy ? '<p>' + terrain.copy + '</p>' : '') +
          '<div class="mmx-quiz__actions">' +
          '<a class="mmx-btn mmx-btn--primary" href="' +
          (terrain.url || '#new-drops') +
          '">Équiper ce tapis</a>' +
          (terrain.universe
            ? '<a class="mmx-btn mmx-btn--ghost" href="' + terrain.universe + '">Voir l’univers</a>'
            : '') +
          '</div>' +
          '<button type="button" class="mmx-quiz__again">Recommencer</button>' +
          '</article>';
        const again = resultEl.querySelector('.mmx-quiz__again');
        if (again) {
          again.addEventListener('click', () => {
            step = 0;
            playerId = 'aim';
            universeKey = 'B';
            resultEl.hidden = true;
            resultEl.innerHTML = '';
            showQuestion();
          });
        }
      };

      showQuestion();
    }
  }

  const players = document.querySelector('[data-mmx-players]');
  if (players && !quizRoot) {
    const tabs = [...players.querySelectorAll('[data-player]')];
    const setPlayer = (id) => {
      tabs.forEach((tab) => {
        const on = tab.getAttribute('data-player') === id;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        const panel = document.getElementById(tab.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
    };
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const id = tab.getAttribute('data-player');
        const already = tab.getAttribute('aria-selected') === 'true';
        setPlayer(already ? '' : id);
      });
    });
  }

  const hotspots = document.querySelectorAll('[data-mmx-hotspots]');
  hotspots.forEach((root) => {
    const buttons = [...root.querySelectorAll('[data-spot]')];
    const panels = [...root.querySelectorAll('[data-spot-panel]')];
    const setSpot = (id) => {
      buttons.forEach((btn) => {
        const on = btn.getAttribute('data-spot') === id;
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      panels.forEach((panel) => {
        const on = panel.getAttribute('data-spot-panel') === id;
        panel.hidden = !on;
      });
    };
    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const id = btn.getAttribute('data-spot');
        const already = btn.getAttribute('aria-pressed') === 'true';
        if (already) {
          setSpot('');
          return;
        }
        setSpot(id);
      });
    });
  });

  const terrainRoot = document.querySelector('[data-mmx-terrains]');
  if (terrainRoot) {
    const tabs = [...terrainRoot.querySelectorAll('[data-mmx-terrain]')];
    const pads = [...terrainRoot.querySelectorAll('[data-mmx-pad]')];
    const status = terrainRoot.querySelector('[data-mmx-terrain-status]');
    const panel = terrainRoot.querySelector('#mmx-pads');
    const labels = {
      all: 'Tous les tapis',
      'dark-core': 'Dark Core',
      'black-chrome': 'Black Chrome',
      'tokyo-graffiti': 'Tokyo Graffiti',
    };

    const setTerrain = (key, { focus } = {}) => {
      const next = labels[key] ? key : 'all';
      tabs.forEach((tab) => {
        const on = tab.getAttribute('data-mmx-terrain') === next;
        tab.classList.toggle('is-on', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        if (on && panel) panel.setAttribute('aria-labelledby', tab.id);
        if (on && focus) tab.focus();
      });
      let visible = 0;
      pads.forEach((pad) => {
        const show = next === 'all' || pad.getAttribute('data-mmx-pad') === next;
        pad.hidden = !show;
        if (show) visible += 1;
      });
      if (status) {
        const active = tabs.find((tab) => tab.getAttribute('data-mmx-terrain') === next);
        const href = active && active.getAttribute('data-mmx-terrain-url');
        const name = labels[next] || 'Tous';
        if (next === 'all') {
          status.innerHTML =
            visible + ' tapis · <a href="#joueurs">Trouver mon terrain</a>';
        } else {
          status.innerHTML =
            visible +
            ' tapis · ' +
            name +
            (href ? ' · <a href="' + href + '">Voir l’univers</a>' : '');
        }
      }
      if (history.replaceState) {
        const url = new URL(window.location.href);
        if (next === 'all') url.hash = terrainRoot.id || 'new-drops';
        else url.hash = 'terrain=' + next;
        history.replaceState(null, '', url);
      }
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => setTerrain(tab.getAttribute('data-mmx-terrain')));
      tab.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        const dir = event.key === 'ArrowRight' ? 1 : -1;
        const i = (index + dir + tabs.length) % tabs.length;
        setTerrain(tabs[i].getAttribute('data-mmx-terrain'), { focus: true });
      });
    });

    const hash = (window.location.hash || '').replace('#', '');
    const fromHash = hash.indexOf('terrain=') === 0 ? hash.slice(8) : 'all';
    setTerrain(fromHash);
  }

  document.querySelectorAll('.mmx-card').forEach((card) => {
    const on = () => card.classList.add('is-mmx-on');
    const off = () => card.classList.remove('is-mmx-on');
    card.addEventListener('pointerdown', on);
    card.addEventListener('pointerup', off);
    card.addEventListener('pointerleave', off);
    card.addEventListener('pointercancel', off);
  });

  if (reduce.matches) return;

  const reveal = document.querySelectorAll('.mmx-reveal');
  if (reveal.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );
    reveal.forEach((el) => io.observe(el));
  }

  const hero = document.querySelector('[data-mmx-hero]');
  if (hero && fine.matches) {
    const layers = [...hero.querySelectorAll('[data-depth]')];
    const pad = hero.querySelector('[data-mmx-pad]');
    const narrow = window.matchMedia('(max-width: 989px)');
    let tx = 0.5;
    let ty = 0.5;
    let cx = 0.5;
    let cy = 0.5;
    let raf = 0;

    const apply = () => {
      const dx = cx - 0.5;
      const dy = cy - 0.5;
      const amp = narrow.matches ? 28 : 48;
      hero.style.setProperty('--mmx-mx', (cx * 100).toFixed(2) + '%');
      hero.style.setProperty('--mmx-my', (cy * 100).toFixed(2) + '%');
      layers.forEach((layer) => {
        const depth = parseFloat(layer.getAttribute('data-depth')) || 0;
        layer.style.setProperty('--px', (-dx * amp * depth).toFixed(2) + 'px');
        layer.style.setProperty('--py', (-dy * amp * 0.38 * depth).toFixed(2) + 'px');
      });
      if (pad) {
        const baseX = parseFloat(getComputedStyle(hero).getPropertyValue('--tilt-x')) || 12;
        const baseY = parseFloat(getComputedStyle(hero).getPropertyValue('--tilt-y')) || -8;
        pad.style.setProperty('--tilt-x', (baseX + dy * 2.8).toFixed(3) + 'deg');
        pad.style.setProperty('--tilt-y', (baseY + dx * -3.6).toFixed(3) + 'deg');
        pad.style.setProperty('--glx', (58 + dx * 14).toFixed(1) + '%');
        pad.style.setProperty('--gly', (40 + dy * 10).toFixed(1) + '%');
      }
    };

    const tick = () => {
      cx += (tx - cx) * 0.08;
      cy += (ty - cy) * 0.08;
      apply();
      if (Math.abs(tx - cx) > 0.001 || Math.abs(ty - cy) > 0.001) {
        raf = window.requestAnimationFrame(tick);
      } else {
        raf = 0;
      }
    };

    const start = () => {
      if (!raf) raf = window.requestAnimationFrame(tick);
    };

    hero.addEventListener(
      'pointermove',
      (event) => {
        if (event.pointerType && event.pointerType !== 'mouse') return;
        const box = hero.getBoundingClientRect();
        if (!box.width || !box.height) return;
        tx = (event.clientX - box.left) / box.width;
        ty = (event.clientY - box.top) / box.height;
        start();
      },
      { passive: true }
    );

    hero.addEventListener('pointerleave', () => {
      tx = 0.5;
      ty = 0.5;
      start();
    });
  }

  const deskOk = window.matchMedia('(min-width: 990px)');
  if (fine.matches && deskOk.matches) {
    document.querySelectorAll('[data-mmx-gate]').forEach((gate) => {
      const layers = [...gate.querySelectorAll('[data-depth]')];
      const pad = gate.querySelector('[data-mmx-pad]');
      let tx = 0.5;
      let ty = 0.5;
      let cx = 0.5;
      let cy = 0.5;
      let raf = 0;
      const apply = () => {
        const dx = cx - 0.5;
        const dy = cy - 0.5;
        layers.forEach((layer) => {
          const depth = parseFloat(layer.getAttribute('data-depth')) || 0;
          layer.style.setProperty('--px', (-dx * 22 * depth).toFixed(2) + 'px');
          layer.style.setProperty('--py', (-dy * 10 * depth).toFixed(2) + 'px');
        });
        if (pad) {
          pad.style.setProperty('--tilt-x', (10 + dy * 2).toFixed(2) + 'deg');
          pad.style.setProperty('--tilt-y', (-5 + dx * -2.4).toFixed(2) + 'deg');
        }
      };
      const tick = () => {
        cx += (tx - cx) * 0.08;
        cy += (ty - cy) * 0.08;
        apply();
        if (Math.abs(tx - cx) > 0.001 || Math.abs(ty - cy) > 0.001) raf = window.requestAnimationFrame(tick);
        else raf = 0;
      };
      const start = () => {
        if (!raf) raf = window.requestAnimationFrame(tick);
      };
      gate.addEventListener(
        'pointermove',
        (event) => {
          if (event.pointerType && event.pointerType !== 'mouse') return;
          const box = gate.getBoundingClientRect();
          if (!box.width || !box.height) return;
          tx = (event.clientX - box.left) / box.width;
          ty = (event.clientY - box.top) / box.height;
          start();
        },
        { passive: true }
      );
      gate.addEventListener('pointerleave', () => {
        tx = 0.5;
        ty = 0.5;
        start();
      });
    });
  }

  const sticky = document.querySelector('[data-mmx-sticky-atc]');
  const stickyAdd = document.querySelector('[data-mmx-sticky-add]');
  const mobile = window.matchMedia('(max-width: 749px)');
  if (sticky && stickyAdd) {
    const realAdd = () =>
      [...document.querySelectorAll(
        'product-form-component button[type="submit"], .product-details button[name="add"], .product-information button[name="add"]'
      )].find((btn) => !btn.closest('#cart-drawer, cart-drawer-component, .mmx-cart-upsell'));

    stickyAdd.addEventListener('click', () => {
      if (stickyAdd.disabled) return;
      const btn = realAdd();
      if (btn && !btn.disabled) btn.click();
    });

    let observer;
    const syncSticky = () => {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
      if (!mobile.matches) {
        sticky.hidden = true;
        document.body.classList.remove('is-mmx-sticky');
        return;
      }
      const btn = realAdd();
      if (!btn) {
        sticky.hidden = true;
        document.body.classList.remove('is-mmx-sticky');
        return;
      }
      observer = new IntersectionObserver(
        (entries) => {
          const visible = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio > 0.12);
          sticky.hidden = visible;
          document.body.classList.toggle('is-mmx-sticky', !visible);
        },
        { threshold: [0, 0.12, 1] }
      );
      observer.observe(btn);
    };

    sticky.hidden = true;
    window.addEventListener('resize', syncSticky);
    mobile.addEventListener('change', syncSticky);
    requestAnimationFrame(syncSticky);
  }
})();
